import { publicDogModel } from "../types/publicDogModel";
import profile from "../images/temp.svg";
import { capitalizeWords } from "../utils/capitalizeWords";
import { useNavigate } from "react-router-dom";
import { calculateAge } from "../utils/calculateAge";

interface DogCardProps {
  dog: publicDogModel;
}

const DonateDogCard: React.FC<DogCardProps> = ({ dog }) => {
  const navigate = useNavigate();
  if (!dog.images || dog.images.length === 0) {
    dog.images = [{ id: 0, image: profile }];
  }

  return (
    <section className="w-[280px] overflow-hidden rounded-2xl bg-gray-50 font-poppins text-gray-dark shadow-lg">
      {/* Image Section */}
      <div className="h-[280px] w-full overflow-hidden rounded-2xl bg-gray-50 p-2">
        <img
          src={dog.images[0].image}
          alt={dog.images[0].alt ?? dog.name}
          className="h-full w-full object-cover object-center rounded-xl"
        />
      </div>

      {/* Content Section */}
      <div className="p-6">
        {/* Dog Name */}
        <h1 className="mb-4 text-center text-2xl font-bold text-black">
          {dog.name}
        </h1>

        {/* Dog Details */}
        <div className="mb-6 flex flex-col space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="font-semibold">ID</span>
            <span className="text-right">#{dog.dog_id}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Sex</span>
            <span className="text-right">{capitalizeWords(dog.sex)}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Age</span>
            <span className="text-right">{calculateAge(dog.age)}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Est. Breed</span>
            <span className="max-w-[150px] text-right">
              {capitalizeWords(dog.breed)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Weight</span>
            <span className="text-right">{dog.weight} lbs</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Location</span>
            <span className="max-w-[150px] text-right">
              {dog.shelter_name !== "Unknown" &&
                dog.address.city !== "" &&
                `${dog.address.city}, ${dog.address.state}`}
              {dog.shelter_name !== "Unknown" &&
                dog.address.city === "" &&
                `${dog.address.state}`}
              {dog.shelter_name === "Unknown" &&
                dog.address.city !== "" &&
                `${dog.address.city}, ${dog.address.state}`}
              {dog.shelter_name === "Unknown" &&
                dog.address.city === "" &&
                `${dog.address.state}`}
            </span>
          </div>
        </div>

        {/* View Profile Button */}
        <button
          className="w-full rounded-md bg-yellow py-2.5 font-semibold text-black shadow-md transition-colors hover:bg-yellow/90 focus:outline-none focus:ring-2 focus:ring-yellow focus:ring-opacity-50"
          onClick={() => {
            navigate(`/browse/${encodeURIComponent(dog.dog_id)}`);
          }}
        >
          View Profile
        </button>
      </div>
    </section>
  );
};

export default DonateDogCard;

